import React from "react";
import { Box, Typography, Paper, useMediaQuery, useTheme } from "@mui/material";
import Texts from "../_constants/Texts/Texts";

export default function Dashboard() {
    const labels = Object.values(Texts.LABELS);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const Card = ({ children }: { children: React.ReactNode }) => (
        <Paper
            elevation={6}
            sx={{
                width: isMobile? "95%" : 300,
                height: 450,
                borderTopLeftRadius: 50,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
                backgroundColor: '#FFFFFE',
                px: isMobile ? 0 : 2,
                mb: isMobile ? 4 : 0,
            }}
        >
            {children}
        </Paper>
    );

    const logoCard = (
        <Card>
            <Box
                component="img"
                src="./CMYK_AF_StartUp_2024.svg"
                alt="AFS Logo"
                sx={{
                    height: "60%",
                    mb: 10,
                    objectFit: "contain",
                    maxWidth: "80%",
                }}
            />
        </Card>
    );

    const textCard = (
        <Card>
            <Box display="flex" flexDirection="column" gap="1rem" mb={6}>
                {labels.map((text) => (
                    <Typography
                        key={text}
                        variant="h6"
                        sx={{ color: "#485150", fontWeight: 600, textAlign: "center" }}
                    >
                        {text}
                    </Typography>
                ))}
            </Box>
        </Card>
    );

    return (
        <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems="center"
            justifyContent="center"
            gap={isMobile ? 4 : 25}
            pt={isMobile ? 5 : 0}
            width="100%"
            flexWrap="wrap"
        >
            {logoCard}
            {textCard}
        </Box>
    );
}
